import { motion } from "framer-motion";
import { Navigation } from "lucide-react";

const MAP_SRC =
  "https://www.google.com/maps?q=Mount+Taranaki,+New+Zealand&z=9&t=m&output=embed";

export default function TaranakiMap() {
  return (
    <motion.div
      data-testid="taranaki-map"
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="relative mt-16 overflow-hidden border border-white/[0.08] bg-[#131924]"
    >
      <div className="pointer-events-none absolute bottom-0 left-0 z-10 flex items-center gap-3 bg-[#0B0F17]/90 px-5 py-3 backdrop-blur sm:bottom-auto sm:left-auto sm:right-0 sm:top-0">
        <Navigation className="h-4 w-4 text-orange-400" />
        <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-300">
          Service area — Taranaki region
        </span>
      </div>
      <iframe
        title="Map of Taranaki, New Zealand — Total Roof Care Taranaki service area"
        src={MAP_SRC}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
        data-testid="taranaki-map-iframe"
        className="block h-[340px] w-full sm:h-[420px]"
        style={{ border: 0, filter: "invert(0.92) hue-rotate(180deg) saturate(0.55) brightness(0.85)" }}
      />
      <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_80px_rgba(11,15,23,0.9)]" />
    </motion.div>
  );
}
